import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["to"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { PureComponent } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { parse, parseUrl, stringify } from 'query-string';
import { jsx as _jsx } from "react/jsx-runtime";

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

export var withPreparedLink = function withPreparedLink(WrappedComponent) {
  var WithPreparedLink = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithPreparedLink, _PureComponent);

    var _super = _createSuper(WithPreparedLink);

    function WithPreparedLink() {
      var _this;

      _classCallCheck(this, WithPreparedLink);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _this.getSearch = function (nextSearch) {
        var _this$context = _this.context,
            isMinTemplate = _this$context.isMinTemplate,
            isAppTemplate = _this$context.isAppTemplate,
            isHideBonus = _this$context.isHideBonus,
            isDrawPage = _this$context.isDrawPage,
            isBonusPage = _this$context.isBonusPage;
        var draw = isDrawPage ? 'draw' : undefined;
        var bonus = isBonusPage ? 'bonus' : undefined;
        return stringify(_objectSpread(_objectSpread({}, nextSearch), {}, {
          'min-template': isMinTemplate || undefined,
          'app-template': isAppTemplate || undefined,
          'hide-bonus-button': isHideBonus || undefined,
          'bonus-type': isHideBonus ? draw : nextSearch['bonus-type'],
          'deposit-type': isHideBonus ? Array.from(new Set([].concat(_toConsumableArray((nextSearch['deposit-type'] || '').split(',')), [bonus]))).filter(function (type) {
            return !!type;
          }).join(',') : nextSearch['deposit-type']
        }));
      };

      _this.getLink = function (to) {
        if (!to) {
          return null;
        }

        if (_typeof(to) === 'object' && to !== null) {
          var _queries = _this.getSearch(parse(to.search));

          return _objectSpread(_objectSpread({}, to), {}, {
            search: "".concat(_queries ? '?' : '').concat(_queries)
          });
        }

        var parsedUrl = parseUrl(to);

        var queries = _this.getSearch(parsedUrl.query);

        var search = "".concat(queries ? '?' : '').concat(queries);
        return "".concat(parsedUrl.url).concat(search);
      };

      return _this;
    }

    _createClass(WithPreparedLink, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            to = _this$props.to,
            props = _objectWithoutProperties(_this$props, _excluded);

        var preparedLink = this.getLink(to);
        return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread({
          preparedLink: preparedLink
        }, props));
      }
    }]);

    return WithPreparedLink;
  }(PureComponent);

  WithPreparedLink.defaultProps = {
    to: null
  };
  WithPreparedLink.displayName = "WithPreparedLink(".concat(getDisplayName(WrappedComponent), ")");
  hoistNonReactStatics(WithPreparedLink, WrappedComponent);
  return WithPreparedLink;
};
export default withPreparedLink;